import React, { useState } from "react";
import { map } from "lodash";
import "./App.css";
import { useProducts } from "./hooks/useProducts";
import { ProductTile } from "./components/ProductTile";
import { Cart } from "./components/Cart";
import { Product } from "./types/Product";
import { CartItem } from "./types/Cart";
import { addToCart as addToCartHelper, decrementFromCart } from "./lib/cart";

function App() {
  const { products, loading, error } = useProducts();
  const [cartItems, setCartItems] = useState<CartItem[]>([]);

  const handleAddToCart = (product: Product) => {
    setCartItems((prevItems) => addToCartHelper(prevItems, product));
  };

  const handleDecrement = (productId: number) => {
    setCartItems((prevItems) => decrementFromCart(prevItems, productId));
  };

  if (loading) return <div className="loading">Loading products...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="App">
      <header className="app-header" style={{ textAlign: "left" }}>
        <h1>
          EQUAL <br /> EXPERTS STORE
        </h1>
      </header>
      <div className="app-container">
        <main className="products-section">
          <div className="product-grid">
            {map(products, (product) => (
              <ProductTile
                key={product.id}
                product={product}
                onAddToCart={handleAddToCart}
              />
            ))}
          </div>
        </main>
        <aside className="cart-section">
          <Cart
            items={cartItems}
            onDecrement={handleDecrement}
            onIncrement={handleAddToCart}
          />
        </aside>
      </div>
    </div>
  );
}

export default App;
